import { Injectable, isDevMode } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  public static logContext(context: any, error?: any) {
    if(!isDevMode()) return;
    const className = context.constructor ? context.constructor.name : 'UnknownClass';
    const methodName = context.logContext ? context.logContext.name : 'UnknownMethod';

    console.group(`DEBUG Context : ${document.location.href} ${className}.${methodName}`);

    if (error) {
      if (error.stack == undefined && error.message == undefined) console.error('Stack Trace:', error);
      else if (error?.stack != undefined) console.error('Stack Trace:', error?.stack);
      else if (error?.message != undefined) console.error('Error Message:', error?.message);
    }

    console.log('Context Object:', this.stringifySafe(context));
    console.groupEnd();
  }

  public static  stringifySafe(obj: any): any {
    const seen = new WeakSet();

    function _recurse(value: any, depth: number): any {
      if (value === null || typeof value !== "object") return value;

      if (seen.has(value)) return '[Circular]';
      seen.add(value);

      if (Array.isArray(value)) {
        return value.slice(0, 150).map((v) => _recurse(v, depth + 1));
      }

      if (depth >= 10) return '[Truncated]';

      const result: any = {};
      for (const key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          try {
            result[key] = _recurse(value[key], depth + 1);
          } catch {
            result[key] = '[Error]';
          }
        }
      }
      return result;
    }
    return _recurse(obj, 0);
  }


}
